var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipperguideLogoDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 253.69 34.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.25,
    y1: 33.7,
    x2: 33.7,
    y2: 0.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#00d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84f11e"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M22.19,11.34H13.23V0h19.82c.53,0,.97,.43,.97,.95V20.79h-11.34V11.82c0-.26-.22-.48-.48-.48Zm-10.37,11.34c-.27,0-.48-.21-.48-.48V0L.28,10.93h0C.11,11.1,0,11.34,0,11.61h0v21.46H0c0,.53,.43,.95,.97,.95H22.28c.27,0,.51-.11,.68-.28l11.06-11.06H11.82Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.61,24.56l4.76-3.73c1.06,1.77,2.67,2.77,4.35,2.77s2.67-1.06,2.67-2.18c0-1.4-1.99-1.83-4.2-2.49-2.98-.87-6.5-2.14-6.5-6.65,0-3.95,3.23-6.96,7.9-6.96,4.01,0,6.34,1.65,8.08,3.61l-4.35,3.33c-.84-1.37-2.18-2.21-3.7-2.21s-2.46,.84-2.46,1.9c0,1.37,1.96,1.83,4.2,2.52,3.05,.93,6.65,2.3,6.65,6.81,0,3.89-3.01,7.43-8.3,7.43-4.54,0-7.12-1.93-9.11-4.13Z",
    style: {
      fill: "#333d47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,19.61h-6.53v8.73h-5.44V5.66h5.44V14.27h6.53V5.66h5.41V28.35h-5.41v-8.73Z",
    style: {
      fill: "#333d47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.82,5.66h5.47V28.35h-5.47V5.66Z",
    style: {
      fill: "#333d47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.68,5.66h7.74c5.32,0,8.7,3.76,8.7,8.3s-3.36,8.42-8.73,8.42h-2.27v5.97h-5.44V5.66Zm5.44,4.94v6.75h2.08c1.96,0,3.42-1.34,3.42-3.36s-1.46-3.39-3.42-3.39h-2.08Z",
    style: {
      fill: "#333d47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.21,5.66h7.74c5.32,0,8.7,3.76,8.7,8.3s-3.36,8.42-8.73,8.42h-2.27v5.97h-5.44V5.66Zm5.44,4.94v6.75h2.08c1.96,0,3.42-1.34,3.42-3.36s-1.46-3.39-3.42-3.39h-2.08Z",
    style: {
      fill: "#333d47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.73,5.66h13.46v5.04h-8.05v3.73h8.05v5.04h-8.05v3.85h8.05v5.04h-13.46V5.66Z",
    style: {
      fill: "#333d47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.39,5.66h7.68c5.47,0,8.55,3.51,8.55,7.8,0,2.92-1.31,5.63-4.07,6.9l4.72,7.99h-6.12l-5.35-9.76v9.76h-5.41V5.66Zm5.41,4.97v5.97h1.86c2.3,0,3.45-1.49,3.45-3.08,0-1.87-1.18-2.89-3.45-2.89h-1.86Z",
    style: {
      fill: "#333d47"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M161.58,17c0-6.43,4.97-11.66,11.87-11.66,4.38,0,8.08,2.33,10.07,5.91l-2.11,1.21c-1.52-2.89-4.38-4.82-7.96-4.82-5.69,0-9.39,4.23-9.39,9.36s3.88,9.36,9.26,9.36,8.36-3.39,8.92-7.8h-9.11v-2.3h11.62v.68c0,6.25-4.07,11.72-11.44,11.72-6.59,0-11.75-5.22-11.75-11.66Z",
    style: {
      fill: "#333d47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.54,20.95V5.66h2.42v15.42c0,2.89,2.27,5.28,5.28,5.28s5.31-2.39,5.31-5.28V5.66h2.42v15.29c0,4.35-3.29,7.71-7.74,7.71s-7.71-3.36-7.71-7.71Z",
    style: {
      fill: "#333d47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.75,5.66h2.42V28.35h-2.42V5.66Z",
    style: {
      fill: "#333d47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.06,5.66h6.34c7.06,0,11.81,4.91,11.81,11.35s-5.04,11.34-11.72,11.34h-6.43V5.66Zm2.42,2.24V26.08h3.82c5.5,0,9.42-3.92,9.42-9.08s-3.67-9.11-9.51-9.11h-3.73Z",
    style: {
      fill: "#333d47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.14,5.66h13.77v2.3h-11.34v7.86h11.34v2.3h-11.34v7.89h11.34v2.33h-13.77V5.66Z",
    style: {
      fill: "#333d47"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M247.88,2.42h-1.07v-.53h2.7v.53h-1.07v3.25h-.56V2.42Z",
    style: {
      fill: "#333d47"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.99,1.89h.56l1.28,1.77,1.32-1.77h.53v3.78h-.56V2.79l-1.31,1.76-1.27-1.72v2.83h-.56V1.89Z",
    style: {
      fill: "#333d47"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipperguideLogoDark);
export default __webpack_public_path__ + "static/media/shipperguide-logo-dark.f7487f79bebaea7839956853b14b48b6.svg";
export { ForwardRef as ReactComponent };